export const groupAllocations = allocations => {
  const result = [];
  let groupId = 0;
  let regionId = 0;
  let schoolId = 0;

  for (let i = 0; i < allocations.length; i++) {
    const allocation = allocations[i];

    /* eslint no-continue: "off" */
    if (
      !allocation.group_id ||
      !allocation.region_id ||
      !allocation.school_id
    ) {
      continue;
    }

    if (allocation.group_id !== groupId) {
      result.push({
        group_id: allocation.group_id,
        group_name: allocation.group_name,
        regions: [
          {
            region_id: allocation.region_id,
            region_name: allocation.region_name,
            schools: [
              {
                school_id: allocation.school_id,
                school_name: allocation.school_name,
                allocations: [allocation.id]
              }
            ]
          }
        ]
      });
    } else if (allocation.region_id !== regionId) {
      result[result.length - 1].regions.push({
        region_id: allocation.region_id,
        region_name: allocation.region_name,
        schools: [
          {
            school_id: allocation.school_id,
            school_name: allocation.school_name,
            allocations: [allocation.id]
          }
        ]
      });
    } else if (allocation.school_id !== schoolId) {
      result[result.length - 1].regions[
        result[result.length - 1].regions.length - 1
      ].schools.push({
        school_id: allocation.school_id,
        school_name: allocation.school_name,
        allocations: [allocation.id]
      });
    } else {
      result[result.length - 1].regions[
        result[result.length - 1].regions.length - 1
      ].schools[
        result[result.length - 1].regions[
          result[result.length - 1].regions.length - 1
        ].schools.length - 1
      ].allocations.push(allocation.id);
    }

    groupId = allocation.group_id;
    regionId = allocation.region_id;
    schoolId = allocation.school_id;
  }

  return result;
};
